import { theme as theme2 } from '@clubspark-react/ui';

import { makeStyles } from 'makeStyles';
import { WHITE } from 'theme/colors';
import { themeV2 } from 'theme/themeV2';

export const useStyles = makeStyles()((theme) => ({
  button: {
    backgroundColor: WHITE,
    fontSize: theme2.fontSizes.medium.value,
    color: themeV2.colors.primary150.value,
    fontWeight: theme2.fontWeights.bold.value,
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    padding: '0',
    flexShrink: 0,
    marginLeft: theme.spacing(1.5),
    cursor: 'pointer',
    '& > :first-child': {
      marginRight: theme.spacing(1),
    },
  },
  error: {
    height: theme.spacing(2.5),
    color: theme2.colors.destructive100main.value,
    fontSize: theme2.fontSizes.medium.value,
    position: 'absolute',
    bottom: theme.spacing(-2.5),
    left: '1px',
  },
  inputContainer: {
    width: theme.spacing(56),
    maxWidth: '80vw',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    marginBottom: theme.spacing(5.6),
  },
  colorRed: {
    color: theme2.colors.destructive100main.value,
  },
}));

export default useStyles;
